import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-month-picker-calendar/dist/react-month-picker-input.css";

export default class WeeklyDriverWagesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:false,
            url:'/api/v1/portal/portal-admin/weekly-driver-wages-report/',
            downloadUrl:'/api/v1/portal/portal-admin/download-total-jobs-raised-by-user-report/',
            totalDrivers:[],
            startDate:moment().toDate(),
            endDate:moment().toDate(),
            filename:'Driver Invoices Report',
            isDownloading:false,
        };
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
    }
    handleStartDateChange(date) {
        this.setState({startDate: date})
    }
    handleEndDateChange(date) {
        this.setState({endDate: date})
    }
    handleTotalJobsRaisedByUserReportGenerate(e) {
        this.setState({isLoading: true});
        let url = this.state.url+moment(this.state.startDate).format("YYYY-MM-DD")+'/'+moment(this.state.endDate).format("YYYY-MM-DD");

        return fetch(url, {
          method: "GET",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token
            , "Accept": 'application/json'
          },
        }).then((responseText) => {
            let response = responseText.json();
            response.then((response) => {
              //console.log(response.users);  
              this.setState({
                totalDrivers: response.drivers,
                isLoading: false
              })
            });
          }).catch(err=>{
            alert('sorry something went wrong.') ;
        });
    }

    downloadableCsvData(filename,text){
        this.setState({isDownloading: true});
        let filenamed = filename+" FROM "+moment(this.state.startDate).format("YYYY-MM-DD")+" TO "+moment(this.state.endDate).format("YYYY-MM-DD")+".csv";
        let textdata = "DRIVER,GEMINI,GEMINI DRIVERS NORTH WEST, MILES\n"+text;
        let element = document.createElement('a');
        element.setAttribute('href','data:text/plain;charset=utf-8,' + encodeURIComponent(textdata));
        element.setAttribute('download', filenamed);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        this.setState({isDownloading: false});
    }
    render() {
        let totalDrivers = [];
        let downloadCsvData = [];
        if(this.state.totalDrivers.length > 0){
            this.state.totalDrivers.map((driver, index) => {
                totalDrivers.push(
                    <tr key={index}>
                        <td className="job-ref-font16">{driver.full_name}</td>
                        <td>&pound;{parseFloat(driver.geminiTotal).toFixed(2)}</td>
                        <td>&pound;{parseFloat(driver.gdnwTotal).toFixed(2)}</td>
                        <td>{ parseFloat(driver.miles).toFixed(2)}</td>
                    </tr>
                );
                downloadCsvData = downloadCsvData +
                            driver.full_name+','+
                            (parseFloat(driver.geminiTotal).toFixed(2))+','+
                            (parseFloat(driver.gdnwTotal).toFixed(2))+','+
                            (driver.miles)+"\n";
            });
        }else{
            totalDrivers.push(
               <tr key='no-records'><td colSpan="7" className='text-center'>No Records</td></tr>
            );
        }
        return (
            <div className="container-fluid">
                <div className="row">
                    <h2>Weekly Driver Invoices Report</h2>
                    <br/><br/><br/>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        Select From Date:
                    </div>
                    <div className="col-md-2">
                       Select To Date:
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleStartDateChange} selected={this.state.startDate}/>
                    </div>
                    <div className="col-md-2">
                        <DatePicker todayButton={"Today"} dateFormat="dd/MM/yyyy" onChange={this.handleEndDateChange} selected={this.state.endDate}/>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-success btn-lg" disabled={this.state.isLoading ? true:false} onClick={(e) => this.handleTotalJobsRaisedByUserReportGenerate(e)}>
                                <i className="fa fa-download"></i> Generate Report
                            </button>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <button className="btn btn-primary btn-lg" disabled={this.state.isDownloading ? true:false} onClick={(e) => {this.downloadableCsvData(this.state.filename,downloadCsvData)}}>
                                <i className="fa fa-download"></i> Download Report {this.state.isDownloading ? <i className="fa fa-spinner fa-pulse"></i> : ''}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-10 col-sm-10">
                        <h4 className="alert alert-info text-center">{(this.state.totalDrivers.length > 0 ? this.state.totalDrivers.length -1 : this.state.totalDrivers.length)} drivers found..</h4>
                        <div className="daily-delivered-report-tbl-scroll">
                            <table className="daily-delivered-report-tbl">
                                <thead className="sticky-top-without-zindex bg-light">
                                   <tr>
                                        <th>Driver</th>
                                        <th>Gemini</th>
                                        <th>Gemini Drivers North West</th>
                                        <th>MILES</th>
                                   </tr>
                                </thead>
                                <tbody>
                                    {this.state.isLoading ? (<tr><td colSpan="7"><span className="add-loading-text"><i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :totalDrivers}
                                </tbody>
                            </table>
                        </div>
                        <br/><br/><br/>
                    </div>
                </div>
            </div>
        );
    }
}
if (document.getElementById('react-component-g4-logistics-portal-weekly_driver_wages_report')) {
    ReactDOM.render(
        <WeeklyDriverWagesReport message_if_none = 'Nothing to report on.' />,
        document.getElementById('react-component-g4-logistics-portal-weekly_driver_wages_report')
    );
}
